// extracted by mini-css-extract-plugin
export default {"root":"src__modules__store__store-page__root"};